import React, { useState } from "react";
import "./Toolbar.css";
import PngExporter from "../PngExporter";
import FeatureInfo from "../FeatureInfo";
import DistanceMeasurer from "../DistanceMeasurer";
import AreaMeasurer from "../AreaMeasurer";
import { Tooltip } from "primereact/tooltip";
import { useTranslation } from "react-i18next";
import icondatabase from '../../_assets/img/database.png'
import { Button } from "primereact/button";
import DownloadDadosModal from "./components/download/download";
const Toolbar = (props) => {
  const [activeTool, setActiveTool] = useState(null);
  const { t } = useTranslation();

  const handleActiveTool = (instance) => {
    setActiveTool(instance);
  };

  const [showDownloadModal, setShowDownloadModal] = useState(false);

  return (
    <div className="Toolbar">
     {/*     <Tooltip
        target=".GestorLink"
        content={t("gestor.buttonTooltip")}
        position="bottom"
        className="CustomTooltip"
      />
      <a
        href="https://pedea.sema.ce.gov.br/gestor"
        target="_blank"
        rel="noreferrer"
        className="GestorLink"
      >
         <i className="pi pi-server GestorIcon" />
      </a> */}

      <Tooltip
        target=".BtnDownload"
        content={t("layerSwitcher.downloadData")}
        position="bottom"
        className="CustomTooltip"
      />

      <Button
        icon="pi pi-download"
        className="BtnDownload"
        aria-label={t("layerSwitcher.downloadData")}
        onClick={() => setShowDownloadModal(true)}
      />

      <DownloadDadosModal
        active={showDownloadModal}
        close={() => setShowDownloadModal(false)}
        title={t("layerSwitcher.downloadData")}
      />
      <FeatureInfo
        map={props.map}
        handleActiveTool={handleActiveTool}
        activeTool={activeTool}
      />
     {/* <PngExporter
        map={props.map}
        handleActiveTool={handleActiveTool}
        activeTool={activeTool}
      /> */}
      <DistanceMeasurer
        map={props.map}
        handleActiveTool={handleActiveTool}
        activeTool={activeTool}
      />
      <AreaMeasurer
        map={props.map}
        handleActiveTool={handleActiveTool}
        activeTool={activeTool}
      />
    </div>
  );
};

export default Toolbar;
